/* Jaypore product-card image slider — arrow navigation + dot sync + swipe.
   Swiping is native touch scrolling (overflow-x: auto + scroll-snap) — the
   browser guarantees that always moves on a drag, unlike a hand-rolled
   touch handler that can silently do nothing if its gesture heuristics
   don't match a real swipe. scroll-snap-stop: always keeps most browsers to
   one slide per flick; for the rest (notably Firefox, which doesn't support
   scroll-snap-stop) this also watches where a swipe started and, once the
   scroll settles, clamps any overshoot back to exactly one slide.
   Works via event delegation so it also covers cards injected later
   (AJAX collection filtering, recently-viewed fetch, etc). */
(function () {
  function trackIndex(track) {
    return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
  }

  function syncDots(slider, index) {
    var dots = slider.querySelectorAll('[data-jpc-slider-dots] .jpc__slider-dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('[data-jpc-slider-prev]');
    var nextBtn = e.target.closest('[data-jpc-slider-next]');
    if (!prevBtn && !nextBtn) return;

    var slider = (prevBtn || nextBtn).closest('[data-jpc-slider]');
    var track = slider && slider.querySelector('[data-jpc-slider-track]');
    if (!track) return;

    e.preventDefault();
    e.stopPropagation();
    track.scrollBy({ left: (nextBtn ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
  });

  var scrollTimers = new WeakMap();

  document.addEventListener(
    'touchstart',
    function (e) {
      var track = e.target.closest && e.target.closest('[data-jpc-slider-track]');
      if (!track) return;
      track.dataset.jpcStartIndex = trackIndex(track);
    },
    { passive: true }
  );

  document.addEventListener(
    'scroll',
    function (e) {
      var track = e.target;
      if (!track || !track.matches || !track.matches('[data-jpc-slider-track]')) return;
      var slider = track.closest('[data-jpc-slider]');
      if (!slider || !track.clientWidth) return;

      syncDots(slider, trackIndex(track));

      clearTimeout(scrollTimers.get(track));
      scrollTimers.set(
        track,
        setTimeout(function () {
          var startIndex = Number(track.dataset.jpcStartIndex || 0);
          var maxIndex = track.children.length - 1;
          var endIndex = Math.max(0, Math.min(maxIndex, trackIndex(track)));
          var diff = endIndex - startIndex;
          /* A flick that carried past more than one slide (scroll-snap-stop
             isn't honored, or the drag started mid-momentum) — settle it
             back to exactly one slide from where the gesture started. */
          if (Math.abs(diff) > 1) {
            var corrected = startIndex + (diff > 0 ? 1 : -1);
            track.scrollTo({ left: corrected * track.clientWidth, behavior: 'smooth' });
          }
        }, 120)
      );
    },
    true
  );

  /* Lazy-load + play/pause product-card videos only while they're actually
     on screen. Loading & autoplaying every card's video at once (a whole
     collection grid of them) is what freezes the page — this caps it to
     whatever's currently visible. */
  if ('IntersectionObserver' in window) {
    var jpcVideoObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (!video.src && video.dataset.src) {
              video.src = video.dataset.src;
            }
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.15 }
    );

    var observeJpcVideo = function (video) {
      jpcVideoObserver.observe(video);
    };

    document.querySelectorAll('[data-jpc-video]').forEach(observeJpcVideo);

    /* Cards render later too (AJAX collection filtering, recently-viewed
       fetch, similar-products carousel) — pick those videos up as well. */
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.matches && node.matches('[data-jpc-video]')) observeJpcVideo(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('[data-jpc-video]').forEach(observeJpcVideo);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
